module.exports = __webpack_public_path__ + "img/photo3_6.d9191ab0.jpg";